import {Component} from '@angular/core';

import {ActivatedRoute} from '@angular/router';
import {SessionService} from '../@core/session.service';
import {NzSkeletonModule} from 'ng-zorro-antd/skeleton';

@Component({
  selector: 'app-redirect',
  imports: [NzSkeletonModule],
  template: `
    <nz-skeleton nzLoading="true"></nz-skeleton>
  `,
  styles: []
})
export class RedirectComponent {
  constructor(private actRoute: ActivatedRoute,
              private sess: SessionService) {
  }

  ngOnInit(): void {
    const {token} = this.actRoute.snapshot.params;
    const {module} = this.actRoute.snapshot.queryParams;
    this.sess.ssoSignIn(token, module);
  }
}

